import React, {useEffect} from "react";
import "./styles.scss";
import "./mobile.scss";
import {withRouter} from "react-router-dom/cjs/react-router-dom.min";
import {FormHeader, Navigator, SectionHeader} from "../../../components";
import {getLanguage} from "../../../utils/environment";
import Footer from "../../footer/index";
import {useLocation} from "react-router-dom/cjs/react-router-dom";

const PrivacyPolicy = (props) => {
  const len = getLanguage();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location.pathname]);

  return (
    <>
      <div className="container">
        <Navigator
          data={{ size: "lg", icon: "arrow-left", title: "Privacy Policy" }}
          onClickBack={() => {
            props.history.push("/");
          }}
        />
        <div className={"policy-wrapper"}>
          <div className={"ppw__top"}>
            <FormHeader
              data={{
                size: "lg x",
                mainLayerStyles: "mb-4 pb-2",
                formHeader: "Privacy Policy",
              }}
            />
            <SectionHeader
              data={{
                size: "md x",
                title: "",
              }}
            />
          </div>
          <div className={"ppw__body"}>
            <p>
              <b>Last Updated: Jun 25 2025 </b>

              At hopeofanewera.org, your privacy is our priority. This Privacy Policy outlines how we collect, use,
              disclose, and safeguard your personal information when you visit or interact with our website and
              services.
              By using our services, you agree to the collection and use of information in accordance with this policy.
            </p>

            <h2>Information We Collect</h2>
            <p>
              We may collect the following types of information:
              <ul>
                <li>Personal Information : When you register, subscribe, place an ad, donate, or apply for a job, we may
                  collect:
                  <ul>
                    <li>Full Name</li>
                    <li>Email Address</li>
                    <li>Phone Number</li>
                    <li>Location/Address</li>
                  </ul>
                </li>
              </ul>
              <br/>
              <ul>
                <li>Non-Personal Information : Collected automatically through cookies and analytics tools:
                  <ul>
                    <li>IP address</li>
                    <li>Email Address</li>
                    <li>Pages visited and time spent</li>
                    <li>Device type and operating system</li>
                  </ul>
                </li>
              </ul>
            </p>

            <h2>How We Use Your Information</h2>
            <p>
              Your information may be used to:
              <ul>
                <li>Provide and improve our news, job, and ad services</li>
                <li>Process payments and manage subscriptions</li>
                <li>Communicate with you (notifications, newsletters, updates)</li>
                <li>Customize user experience</li>
                <li>Prevent fraud and maintain website security</li>
                <li>Comply with legal obligations</li>
              </ul>
            </p>

            <h2>Cookies and Tracking Technologies</h2>
            <p>
              We use cookies, Google Analytics, and similar technologies to:
              <ul>
                <li>Remember your preferences</li>
                <li>Analyze site traffic</li>
                <li>Improve website performance</li>
              </ul>
              You can choose to disable cookies in your browser settings, but some site features may not work properly.
            </p>

            <h2>Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your data, including
            </p>
            <ul>
              <li>SSL encryption</li>
              <li>Secure servers</li>
              <li>Access restrictions</li>
              <li>Regular system updates</li>
            </ul>
            <p>
              However, no method of transmission or storage is 100% secure. We encourage users to maintain strong
              passwords and report suspicious activity.
            </p>

            <h2>Your Rights</h2>
            <p>
              Depending on your location, you may have the right to.
              <ul>
                <li>Access your data</li>
                <li>Correct inaccurate data</li>
                <li>Delete your account or data</li>
                <li>Withdraw consent (for marketing emails, cookies, etc.)</li>
              </ul>
              To exercise these rights, contact us at: contact@hopeofanewera.org
            </p>

            <h2>Children’s Privacy</h2>
            <p>
              Our website is not intended for children under the age of 13. We do not knowingly collect personal data
              from children. If you believe a child has submitted information, please contact us immediately.
            </p>

            <h2>Policy Updates</h2>
            <p>
              We may update this Privacy Policy from time to time. Changes will be posted on this page with the revised
              “Jun 25 2025” date. Continued use of our services after changes means you accept the updated policy.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or how we handle your data, please contact:
              <ul>
                <li>📧 Email: contact@hopeofanewera.org</li>
                <li>🌐 Website: https://www.hopeofanewera.org</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default withRouter(PrivacyPolicy);
